import { render, staticRenderFns } from "./Owhat.vue?vue&type=template&id=01928324&scoped=true&"
import script from "./Owhat.vue?vue&type=script&lang=js&"
export * from "./Owhat.vue?vue&type=script&lang=js&"
import style0 from "./Owhat.vue?vue&type=style&index=0&id=01928324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01928324",
  null
  
)

export default component.exports